module.exports = __webpack_public_path__ + "static/search5-32773222db9d737c5d6a6997e0469157.png";